import src from "IMAGE";
export default { src, width: 154, height: 155, blurWidth: 0, blurHeight: 0};
